var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('grid-three',{attrs:{"title":"Daily Dose","title_hi":"डेली डोज़","items":_vm.items,"isInverted":true,"hasClass":"transparent"}})}
var staticRenderFns = []

export { render, staticRenderFns }